import React, { useState } from 'react'
import { connect } from 'react-redux'
import { shapeUtils } from './shape-utils.js'
import { formatNumberWithCommas } from '../../../../../lib/util'
import { formatLongDate } from '../../../../../lib/util'
import { toNumber } from 'lodash'

// <div style={{ fontSize: '12px' }}>
//   <p>{`Created: ${new Date(this.state.created).toLocaleString()}`}</p>
//   <p style={{ marginTop: '10px' }}>{`Location: ${this.state.latitude}, ${this.state.longitude}`}</p>
//   <p style={{ marginTop: '10px' }}>{`Altitude: ${this.state.altitude}`}</p>
// </div>
let requestPending = false

function convertSecondsToHHMMSS(seconds) {
  const hours = Math.floor(seconds / 3600);
  const remainingSecondsAfterHours = seconds % 3600;
  const minutes = Math.floor(remainingSecondsAfterHours / 60);
  const remainingSeconds = (remainingSecondsAfterHours % 60).toFixed(0);
  const hoursStr = String(hours).padStart(2, '0');
  const minutesStr = String(minutes).padStart(2, '0');
  const secondsStr = String(remainingSeconds).padStart(2, '0');
  // return `${hoursStr}:${minutesStr}:${secondsStr}`;
  return `${hoursStr}:${minutesStr}:${secondsStr}`;
}

const ObjectDetails = props => {
  const { leftToolbarState, userPreferences, geoJson, token, data } = props,
    { editable } = leftToolbarState,
    mapObj = editable.mapObj ? editable.mapObj() : null,
    { created, updated, measureType } = editable,
    [elevationGain, setElevationGain] = useState(null),
    { getLength, getElevationGain, getArea } = shapeUtils,
    { units } = userPreferences,
    createdStr = formatLongDate(created),
    updatedStr = updated ? formatLongDate(updated) : 'NA',
    entries = [],
    populateTrack = () => {
      if (!geoJson) {
        return
      }
      console.log('LL', geoJson.features[0])
      const { stats, elevations } = geoJson.features[0].properties
      const secondElements = elevations ? elevations.map(subArray => subArray[1]) : [];
      const maxSecond = Math.max(...secondElements);
      const minSecond = Math.min(...secondElements);
      if (stats) {
        const {
          // distance,
          elevationGain,
          maxSpeed,
          startTime,
          stopTime,
          averageSpeed,
          tripTime,
        } = stats;
        // Conversion factors based on units
        let denom = units === 'imperial' ? 1609.344 : 1000; // Miles to meters or kilometers to meters
        let scale = units === 'imperial' ? 3.28084 : 1; // Feet to meters or no conversion
        // let distance = geoJson.features[0].properties.stats.distance
        let distance = data[data.length - 1][0]
        // Format distance
        let distStr;
        if (units === 'imperial') {
          if (distance < 804.672) { // Less than 0.5 miles (in yards)
            distStr = `${formatNumberWithCommas(Math.round(distance * 1.094)).toLocaleString()} yards`; // Display in yards
          } else {
            distStr = `${formatNumberWithCommas((distance / denom).toFixed(2))} mi`; // Display in miles if greater than or equal to 0.5 miles
          }
        } else {
          if (distance < 1000) {
            distStr = `${formatNumberWithCommas((distance).toFixed(2))} mts`
          } else {
            distStr = `${formatNumberWithCommas((distance / denom).toFixed(2))} km`; // Metric units in kilometers
          }
        }
        // Calculate minimum and maximum elevations
        const yValues = data.map(d => d[1]); // Extract elevation values from data
        const minElevation = formatNumberWithCommas((Math.floor((Math.min(...yValues) / 10) * 10) * scale).toFixed(0)) + (units === 'imperial' ? ' ft' : ' mts');
        const maxElevation = formatNumberWithCommas((Math.ceil((Math.max(...yValues) / 10) * 10) * scale).toFixed(0)) + (units === 'imperial' ? ' ft' : ' mts');

        // Format elevation gain
        const eleStr = `${formatNumberWithCommas(Math.floor(elevationGain * scale))} ${units === 'imperial' ? 'ft' : 'mts'}`;

        // Convert speeds to appropriate units
        const speedHr = (maxSpeed * 60 * 60) / denom; // Top speed in mi/hr or km/hr
        const averageSpeedHr = (averageSpeed * 60 * 60) / denom; // Average speed in mi/hr or km/hr

        // Convert trip duration to HH:MM:SS format
        let tripDuration = convertSecondsToHHMMSS(tripTime);
        const formatSpeed = (speed) =>
          speed > 10 ? `${Math.round(speed)} mph` : `${speed.toFixed(2)} mph`;

        // Populate entries array
        entries.push(
          ['Started:', new Date(startTime * 1000).toLocaleString()],
          ['Stopped:', new Date(stopTime * 1000).toLocaleString()],
          ['Trip Duration:', tripDuration],
          // [
          //   'Avg Speed:',
          //   `${averageSpeedHr.toFixed(2)} ${units === 'imperial' ? 'mph' : 'kph'}`,
          // ],

          ['Avg Speed:', `${units === 'imperial' ? formatSpeed(averageSpeedHr) : `${averageSpeedHr.toFixed(2)} kph`}`],

          ['Distance:', distStr],
          ['Max. Elev:', maxElevation],
          ['Min. Elev:', minElevation],
          ['Elev. Gain:', eleStr],
          // [
          //   'Top Speed:',
          //   `${speedHr.toFixed(2)} ${units === 'imperial' ? 'mph' : 'kph'}`,
          // ]
          ['Top Speed:', `${units === 'imperial' ? formatSpeed(speedHr) : `${speedHr.toFixed(2)} kph`}`]

        )
      } else {
        const noVal = 0
        entries.push([
          'Started:', new Date().toLocaleString()
        ], [
          'Stopped:', null
        ], [
          'Trip Duration:', `${noVal.toFixed(2)} ${units === 'imperial' ? 'mi' : 'km'}`
        ], [
          'Avg Speed:', `${noVal.toFixed(2)} ${units === 'imperial' ? 'mi' : 'km'}`
        ], [
          'Distance:', `${noVal.toFixed(2)} ${units === 'imperial' ? 'mi' : 'km'}`
        ], [
          'Max. Elev:', `${noVal.toFixed(2)} ${units === 'imperial' ? 'mi' : 'km'}`
        ], [
          'Min. Elev:', `${Math.round(noVal)} ${units === 'imperial' ? 'mi' : 'km'}`
        ], [
          'Elev. Gain:', `${Math.round(noVal)} ${units === 'imperial' ? 'ft' : 'm'}`
        ], [
          'Top Speed:', `${Math.round(noVal)} ${units === 'imperial' ? 'mph' : 'kph'}`
        ]
        )
      }
    }
  const populatePoly = () => {
    const area = formatNumberWithCommas(getArea(mapObj, units).toFixed(2)),
      per = formatNumberWithCommas(getLength(mapObj, units).toFixed(2)),
      areaStr = area <= 0.25 ? ` ${units === 'imperial' ? (area * 43560).toLocaleString() + " " + 'sq ft' : area + " " + 'ha'}` : `${area} ${units === 'imperial' ? 'ac' : 'ha'}`,
      perStr = units === 'imperial' ? per <= 0.25 ? Math.round(per * 5280) + ' ' + ' ft' : per && per + ' ' + ' mi' : per + 'km'
    entries.push([
      'Perimeter:', perStr
    ], [
      'Area:', areaStr
    ])
  },
    populateLine = () => {
      const len = formatNumberWithCommas(getLength(mapObj, units).toFixed(2)),
        lenStr = `${len} ${units === 'imperial' ? 'mi' : 'km'}`
      entries.push([
        'Length:', lenStr
      ])
      if (!elevationGain && !requestPending) {
        requestPending = true
        if (typeof mapObj === "function")
          getElevationGain(mapObj, token)
            .then(res => {
              const scale = units === 'imperial' ? 3.28084 : 1,
                eleStr = `${formatNumberWithCommas(Math.round(res < 0 ? 0 : res * scale))} ${units === 'imperial' ? 'ft' : 'm'}`
              entries.push([
                'Elev. Gain:', eleStr
              ])
              requestPending = false
              setElevationGain(eleStr)
            })
            .catch(() => {
              setElevationGain('Could not calculate elevation gain.')
            })
      }
      else if (elevationGain) {
        entries.push([
          'Elev. Gain:', elevationGain
        ])
      }
    },
    populateCircle = () => {
      const denom = units === 'imperial' ? mapObj.getRadius() < 402 ? .328074 : 1609.344 : 1000,
        scale = units === 'imperial' ? 0.000247105 : 0.0001,
        shapeRad = mapObj.getRadius() / denom,
        rad = mapObj.getRadius() < 402 ? formatNumberWithCommas(shapeRad.toFixed(0)) : formatNumberWithCommas(shapeRad.toFixed(2)),
        radStr = `${rad} ${units === 'imperial' ? mapObj.getRadius() < 402 ? 'ft' : 'mi' : 'km'}`,
        areaRaw = (Math.PI * Math.pow(mapObj.getRadius(), 2)) * scale,
        area = formatNumberWithCommas(areaRaw.toFixed(2)),
        areaStr = `${area} ${units === 'imperial' ? 'ac' : 'ha'}`
      entries.push([
        'Radius:', radStr
      ], [
        'Area:', areaStr
      ])
    },
    populateEntries = () => {
      if (measureType !== 'track') {
        if (updatedStr == 'NA') {
          entries.push(
            ['Created:', createdStr],
          )
        }
        else {
          entries.push(
            ['Created:', createdStr],
            ['Updated:', updatedStr]
          )
        }
      }
      switch (measureType) {
        case 'polygon':
          return populatePoly()
        case 'line':
          return populateLine()
        case 'circle':
          return populateCircle()
        case 'track':
          return populateTrack()
      }
    }
  populateEntries()

  return (
    <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
      {
        measureType !== 'boundary' ? (
          entries.map((entry, idx) => {
            return (
              <div style={{ display: 'flex', fontSize: '12px', paddingTop: '5px' }} key={idx}>
                <div style={{ width: '75px' }}>{entry[0]}</div>
                <div>{entry[1]}</div>
              </div>
            )
          })) : (
          <div>
            <p>Map Area:</p>
            <img src={editable.photo ? editable.photo.thumbnailUrl : ''}
              style={{ marginTop: '10px', height: 'auto', width: '100%' }}></img>
          </div>
        )
      }
    </div>
  )
}

const mapStateToProps = state => ({
  leftToolbarState: state.leftToolbarState,
  userPreferences: state.userPreferences,
  token: state.auth.token
})

export default connect(mapStateToProps)(ObjectDetails)